<style lang="less">
.music {
  margin: 0 -8px;
  overflow: hidden;

  .banner {
    position: relative;
    background-color: white;
    font-size: 1.4em;
    line-height: 2.2;
    text-align: center;
  }

  .back-btn {
    position: absolute;
    left: .5em;
    top: .5em;
    width: 2.5em;
    height: 1.2em;
    background: url(/static/back.svg) no-repeat left .5em center / contain;
  }

  .applemusic {
    margin: 0 -2px;
  }

  iframe {
    display: block;
    border: none;
    width: 100%;
    height: 500px;
  }

}
</style>

<template>
<div class="music">
  <div class="banner" ref="banner">
    <a href="#/" class="back-btn"></a>
    <span>Music</span>
  </div>
  <div class="applemusic">
    <iframe :style="{
      height: musicHeight + 'px'
    }" src="//tools.applemusic.com/embed/v1/album/1252032972?at=10lPYF"></iframe>
  </div>
</div>
</template>

<script>
export default {
  name: 'Music',
  data () {
    return {
      musicHeight: 500
    }
  },
  methods: {
    updateMusicHeight() {
      this.musicHeight = Math.max(document.documentElement.clientHeight
        - this.$refs.banner.clientHeight, 400)
    }
  },
  mounted() {
    this.updateMusicHeight()
    this.handleWindowResize = () => {
      this.updateMusicHeight()
    }
    window.addEventListener('resize', this.handleWindowResize, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>



// WEBPACK FOOTER //
// Music.vue?299e193e